import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useStyles, useStylesCircularProgress } from './styles';

const LoadingSpinner = () => {
  const classesCircularProgress = useStylesCircularProgress();
  const classes = useStyles();

  return (
    <div className={classes.loaderWrapper}>
      <div className={classes.loader}>
        <CircularProgress classes={classesCircularProgress} thickness={2} />
      </div>
    </div>
  );
};

export default LoadingSpinner;
